export default __webpack_public_path__ + "static/shipping-7-512b75a4a225d41ddcfffeca659fb301.jpg";